import React from "react";
import { useRouter } from '../router/hooks/index';
import { animalAssets } from'../services/constant';
export default function AnimalCard({ title, count, detail1, detail2, info, isActive, AnimalAvatar }) {

    const router = useRouter();
    const handleClick = () => {
        router.push('/animal/manage')
    }
    return (
        <>        {
            isActive === 1 ?
                (
                    <>
                        <button className="animal_card" onClick={() => handleClick()} >
                            <img src={AnimalAvatar} className="avatar" alt="animal_avatar"></img>
                            <div className="card_title font-22-500"> {title} </div>
                            <div className="card_count font-13-400 font-center">{count} </div>
                            <div className="card_detail1 font-14-400 font-center"> {detail1}</div>
                            <div className="card_detail2 font-14-400 font-center"> {detail2}</div>
                            <div className="card_info font-14-400">
                                {isActive === 1 ? (<img src={animalAssets.IC_SEETING_ACTIVE} alt="" />) : (<img src={animalAssets.IC_SETTING} alt="" />)}

                                <span className={isActive === 1 ? 'active' : ''}>{info}</span></div>
                        </button>
                    </>
                )
                :
                (<>
                    <button className="animal_card" onClick={() => handleClick()} >
                        <img src={AnimalAvatar} className="avatar" alt="animal_avatar"></img>
                        <div className="card_title font-22-500"> {title} </div>
                        <div className="card_count font-13-400 font-center">{count} </div>
                        <div className="card_detail1 font-14-400 font-center"> {detail1}</div>
                        <div className="card_detail2 font-14-400 font-center"> {detail2}</div>
                        <div className="card_info font-14-400">
                            {isActive === 1 ? (<img src={animalAssets.IC_SEETING_ACTIVE} alt="" />) : (<img src={animalAssets.IC_SETTING} alt="" />)}

                            <span className={isActive === 1 ? 'active' : ''}>{info}</span></div>
                    </button>
                </>
                )
        }
        </>

    );
}